module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_aqua-8684d76fa3e6524ff403007bcc1af2de.svg";